module.exports = {"buildDate":"12 Aug 2025","buildNumber":3}


//////////////////
// WEBPACK FOOTER
// ./src/build-info.json
// module id = 1886
// module chunks = 1